import * as actions from "../actionTypes"

// autofit diagram to page - global setting
const initialState = {
    value: 100,
}

export default function autofitDiagram(state = initialState, action) {
    switch (action.type) {
        case actions.SET_DIAGRAM_SCALE: {
            return {
                ...state,
                value: action.payload.value,
            }
        }

        default:
            return state
    }
}
